import { FilterOutlined } from "@ant-design/icons"
import { Button } from "antd"
import { type Store } from "antd/lib/form/interface"
import React, { type ComponentType } from "react"
import { useTranslation } from "react-i18next"
import { FilterModal } from "~Components/filter/FilterModal"
import { type FilterFormProps } from "~Components/filter/filterTypes"

interface FilterProps<FilterValuesType extends Store = Store> {
    FilterForm: ComponentType<FilterFormProps<FilterValuesType>>
    isFilterModalShowing: boolean
    showFilterModal: () => void
    hideFilterModal: () => void
    onFilter: (values: FilterValuesType) => void
    filters: FilterValuesType
    disabled?: boolean
}

export const Filter = ({ FilterForm, isFilterModalShowing, showFilterModal, hideFilterModal, filters, onFilter, disabled = false }: FilterProps) => {
    const { t } = useTranslation()

    return (
        <>
            <FilterModal isVisible={isFilterModalShowing} hideFilterModal={hideFilterModal} FilterForm={FilterForm} filters={filters} onFilter={onFilter} />

            <Button type="default" className="w-100" onClick={showFilterModal} disabled={disabled}>
                <FilterOutlined />
                {t("action:filter")}
            </Button>
        </>
    )
}
